import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"
import { useEffect } from "preact/hooks"
import useProductGroup from "../hooks/useProductGroup"

import Product from "./Product"

export default function Products() {
    const { products, loading } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading }))
    const { groupedProducts } = useProductGroup();

    useEffect(() => {
        if(window.nostojs) {
            window.nostojs(api => {
                api.loadRecommendations({ skipPageViews: true, skipEvents: true })
            })
        }
    }, [ products.hits ])

    return (
        <div 
            id="ns-product-grid" 
            class={`ns-product-grid ns-page-width ns-grid ns-grid-cols-2 ${loading ? 'ns-loading' : ''}`} 
        >
            {products.hits.map((hit, index) => (
                <Product 
                    key={hit.productId || index}
                    product={hit}
                    highPrioImage={index < 4}
                    groupedProducts={groupedProducts?.find(group => hit.tags1.includes(group.groupId))}
                />
            ))}
        </div>
    )
}
